import React, { useEffect, useState } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function PaymentInformation(props) {
    // props
    const { orderDetails } = props

    // states
    const [authDetails, setAuthDetails] = useState(null)

    useEffect(() => {
        const authRes = orderDetails?.orders?.auth_response
        console.log("orderDetails?.orders ", orderDetails);

        if (authRes) {
            setAuthDetails(JSON.parse(authRes))
        }
    }, [orderDetails])

    return (
        <React.Fragment>
            {/* frac */}
            <div className="frac">
                <div className="header-container d-flex mb-3">
                    <div className="in media-body">
                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Payment details</p>
                        <p className="st-fs-15 mb-1 st-fw-500">
                            <span className="me-2">{orderDetails?.orders?.card_type}</span>
                            <span className="">
                                <span className="me-1">****</span>
                                <span>{orderDetails?.orders?.card_last4}</span>
                            </span>
                        </p>
                        <p className="st-fs-15 mb-1">
                            <span className="text-capitalize">transaction ID:</span>
                            <span className="ms-2">{orderDetails?.orders?.transaction_id}</span>
                        </p>
                        <p className="st-fs-15 mb-1">
                            <span>Payment Status: </span>
                            {orderDetails?.orders?.payment_status}
                        </p>
                        <p className="st-fs-15 mb-1">
                            <span>Payment Date: </span>
                            {orderDetails?.orders?.order_date}
                        </p>
                        <a
                            href={orderDetails?.orders?.transaction_detail_link}
                            target="_blank"
                            rel="noreferrer"
                            className="st-text-primary hover-underline-link st-fs-15">Transaction Details</a>
                    </div>

                    <div className="in ms-auto">
                        <a className="st-round-btn st-btn-transparent d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/">
                            <FeatherIcon
                                icon="credit-card"
                                size="18"
                                className="icon" />
                        </a>
                    </div>
                </div>
            </div>

            {/* frac */}
            <div className="frac border-bottom pb-3 mb-3">
                <div className="header-container d-flex">
                    <div className="in media-body">
                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Buyer Credit Verification</p>
                        <p className="st-fs-15">
                            <span className="text-capitalize">CVV:</span>
                            <span className="ms-2">{authDetails?.source?.cvc_check}</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* frac */}
            <div className="frac">
                <div className="header-container d-flex">
                    <div className="in media-body">
                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Billing address</p>
                        <p className="mb-1 st-fs-15">
                            <span>
                                {`${orderDetails?.orders?.bill_first_name ?? ""} ${orderDetails?.orders?.ship_middle_name ?? ""} ${orderDetails?.orders?.bill_last_name ?? ""}`}
                            </span> <br />
                            <span>
                                {orderDetails?.orders?.bill_address ?? ""}
                            </span> <br />
                            {
                                orderDetails?.orders?.bill_address1 ? (
                                    <React.Fragment>
                                        <span>
                                            {orderDetails.orders.bill_address1}
                                        </span> <br />
                                    </React.Fragment>
                                ) : null
                            }
                            <span>
                                {orderDetails?.orders?.billing_city ?? ""}, {orderDetails?.orders?.billing_state ?? ""} {orderDetails?.orders?.bill_zipcode ?? ""}
                            </span> <br />
                            <span>
                                {orderDetails?.orders?.billing_country ?? ""}
                            </span>
                        </p>
                        {/* <a href="/" className="st-text-primary hover-underline-link st-fs-15">Copy to clipboard</a> <br /> */}
                        {/* <a href="/" className="st-text-primary hover-underline-link st-fs-15">
                                                            <span className="me-2">Show on map</span>
                                                            <FeatherIcon
                                                                icon="map-pin"
                                                                size="16"
                                                                className="icon"
                                                            />
                                                        </a> */}
                    </div>

                    <div className="in ms-auto" style={{ pointerEvents: "none", visibility: 'hidden' }}>
                        <a className="st-round-btn st-btn-transparent d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/">
                            <FeatherIcon
                                icon="truck"
                                size="20"
                                className="icon" />
                        </a>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
